import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { KYMW6100Component } from './kymw6100.component';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { GetCwsUseImageInfoService } from './api-services/get-cws-use-image-info.service';
import { PutImageFileService } from './api-services/put-image-file.service';

/**
 * EC画像指示一覧表画面 モジュール設定クラス
 *
 * @export KYMW6100Module
 * @class KYMW6100Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW6100Component,
  ],
  providers: [
    GetCwsUseImageInfoService,
    PutImageFileService,
  ],
})
export class KYMW6100Module {

}
